import { apiCall, NEW_BE_API } from "../../utils/APIFunctions";

export function createSignatureProcess(params, abortController) {
  return apiCall(
    `${NEW_BE_API}/api/n1/signspace/create-signature-process`,
    "POST",
    JSON.stringify(params),
    abortController.signal
  );
}

export function syncSignatureProcesses(documentId) {
  
  return apiCall(
    `${NEW_BE_API}/api/n1/signspace/fetch-and-sync-signature-processes/${documentId}`,
    "PUT"
  );
}

export function downloadSignedPdf(documentId, signedPdfFileId) {
  return apiCall(
    `${NEW_BE_API}/api/n1/signspace/download-signed-pdf/${documentId}/${signedPdfFileId}`,
    "GET",
  );
}